import React, { useEffect, useState } from "react";
import "./Notification.css";

// icons
import { TbFaceIdError, TbSquareRoundedCheckFilled } from "react-icons/tb";

function Notification({ state, message, type = "success", onClose }) {
  const [visible, setVisible] = useState(state);

  useEffect(() => {
    if (state) {
      setVisible(true);

      const timer = setTimeout(() => {
        setVisible(false);
        onClose();
      }, 5000);

      return () => clearTimeout(timer);
    }
  }, [state, type, onClose]);

  if (!visible) return null;

  return (
    <div className={`Notification ${type}`}>
      <div className="container">
        {type === "error" ? (
          <>
            <TbFaceIdError className="icon" />
            <span>Erreur : {message}</span>
          </>
        ) : (
          <>
            <TbSquareRoundedCheckFilled className="icon" />
            <span>L'opération est un succès !</span>
          </>
        )}
      </div>
    </div>
  );
}

export default Notification;
